import {
  AppDownloadPopup,
  BurgerMenu,
  FanspotListBottomModal,
  HomeEventBannerList,
  LoginPopup,
  NoticePopup,
  ProgressingRewardList,
} from '@components/organisms'
import { BodyWrapper, Caption1, Flex, H5, Input } from '@components/atoms'

import { Observer, observer } from 'mobx-react'
import {
  getIsWebApp,
  POST_MESSAGES,
  sendWTAPostMessage,
} from '@utils/postMessage'
import React, { useEffect, useRef, useState } from 'react'

import LikeArtistList from '@components/organisms/List/LikeArtistList'
import { useScrollRestoration, useStore } from '@utils/hooks'
import HomeArticleList from '@components/organisms/List/HomeArticleList'
import styled from 'styled-components'
import {
  fluent_megaphone_12_filled,
  headset_img,
  reward_button_img,
  search_outline_24px,
  white_pen_fill_24px,
  x_btn_gray_img,
} from '@images/index'
import HomeInPlamListItem from '@components/molecules/box/HomeInPlamListItem'
import { pixelTrack } from '@utils/facebook/pixel'
import { PIXEL_EVENTS } from '@utils/facebook/pixelLogs'
import { Image, SegmentedControl, TabControl } from '@components/molecules'
import InfiniteScroll from 'react-infinite-scroll-component'
import ReactLoading from 'react-loading'
import HomeFanSpotList from '@components/organisms/List/HomeFanSpotList'

const HomeTemplate = ({
  noticePopupList,
  articleList,
  history,
  bannerList,
  contentRef,
  searchWord,
}) => {
  const [isShowLoginPopup, setIsShowLoginPopup] = useState(false) // 로그인 상태
  const [isOpen, setIsOpen] = useState(false) // 햄버거

  const [showDownloadPopup, setShowDownloadPopup] = useState(false) // 앱 다운로드 팝업
  const [showNoticePopup, setShowNoticePopup] = useState(false) // 공지사항 팝업
  const { authStore, loadingStore, articleStore } = useStore()
  const { isInitialLoading, isLoading } = loadingStore

  const [isFanSpotModalOpen, setIsFanSpotModalOpen] = useState(false)
  const [isHaveEventBanner, setIsHaveEventBanner] = useState(false)

  const parentRef = useRef(null)
  const [parentOffset, setParentOffset] = useState({ left: 0, width: 0 })

  const [inputValue, setInputValue] = useState(searchWord ? searchWord : '') // view 검색어

  const isWebApp = getIsWebApp({ navigator })

  useEffect(() => {
    const updateOffset = () => {
      if (parentRef.current) {
        const rect = parentRef.current.getBoundingClientRect()

        setParentOffset(rect)
      }
    }

    // 초기 위치 설정
    updateOffset()

    // 창 크기 변경 시 위치 업데이트
    window.addEventListener('resize', updateOffset)
    return () => {
      window.removeEventListener('resize', updateOffset)
    }
  }, [])

  const handleMoveDetail = item => {
    if (!item?._id) return

    history.push({
      pathname: `/fanspot/${item?.isNotice ? 'free-spot' : item?.uniqueName}/${
        item?._id
      }`,
      search: `?offset=0&sortBy=createdAt&category=${item?.articleCategoryId}`,
      state: { fromActivity: 'all' },
    })
  }

  useEffect(() => {
    if (noticePopupList?.length > 0 && !isWebApp) {
      setShowNoticePopup(true)
    }
  }, [noticePopupList])

  useEffect(() => {
    const result =
      bannerList?.findIndex(val => val?.typeList?.includes('EVENT_BANNER')) > -1

    setIsHaveEventBanner(result)
  }, [bannerList])

  return (
    <div ref={contentRef} style={{ height: '100vh', overflow: 'auto' }}>
      <BurgerMenu isHome isOpen={isOpen} setIsOpen={setIsOpen} />
      <BodyWrapper
        ref={parentRef}
        style={
          {
            background: '#fff',
            padding: '64px 0 56px 0',
            overflow: 'visible',
          }
        }
      >
        {
bannerList?.length > 0 && (
            <Flex type={'column'} style={{ marginBottom: '32px' }}>
              <HomeEventBannerList
                bannerList={bannerList}
                setShowDownloadPopup={setShowDownloadPopup}
              />
            </Flex>
          )
        }

        <RewardBanner
          type={'row'}
          style={{ marginBottom: '32px' }}
          onClick={
            () => {
              if (isWebApp) {
                sendWTAPostMessage({
                  window,
                  navigator,
                  postMessageData: POST_MESSAGES.WTA_DATA.MOVE_REWARD_LIST,
                })
              }
              else {
                setShowDownloadPopup(true)
              }
            }
          }
        >
          <Flex align={'center'} style={{ gap: '16px' }}>
            <Image src={headset_img} size={['32px', '32px']} />
            <Flex type={'column'} align={'flex-start'}>
              <Caption1 color={'#646464'}>
                노래 듣고 포인트를 모아보세요
              </Caption1>
              <H5
                style={
                  {
                    fontWeight: 500,
                    marginTop: '4px',
                  }
                }
                type={'Bold'}
              >
                플레이 음감회 즐기기
              </H5>
            </Flex>
          </Flex>
          <Flex
            style={
              {
                padding: '10px 12px',
                borderRadius: '18px',
                background: '#FF5722',
              }
            }
          >
            <Caption1
              type={'Bold'}
              color={'white'}
              style={{ whiteSpace: 'nowrap' }}
            >
              바로가기
            </Caption1>
          </Flex>
        </RewardBanner>

        <HomeFanSpotList
          articleList={articleList}
          handleMoveDetail={handleMoveDetail}
        />
      </BodyWrapper>

      {
        isShowLoginPopup && (
          <LoginPopup handleClose={() => setIsShowLoginPopup(false)} />
        )
      }
      {
        showDownloadPopup && (
          <AppDownloadPopup handleClose={() => setShowDownloadPopup(false)} />
        )
      }
      {
        showNoticePopup && (
          <NoticePopup
            noticePopupList={noticePopupList}
            handleClose={() => setShowNoticePopup(false)}
            type={'notice'}
          />
        )
      }
    </div>
  )
}

export default observer(HomeTemplate)

const RewardBanner = styled(Flex)`
  border-radius: var(--Radius-R16, 16px);
  background: var(--grey-grey_20, #f7f7f7);
  padding: 18px 20px;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 40px);
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 20px;
`
